import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function translateServerLoaderFactory(http: HttpClient, customPath?: string) {
  customPath = customPath || './assets/i18n/';
  // console.log(`translateServerLoaderFactory Called`);
  // console.log(`http: ${JSON.stringify(http)}`);
  // console.log(`custompath${customPath}`);
  return new TranslateHttpLoader(http, customPath, '.json');
}
